import type { PaymentTypeV10 } from '../../../api/generated/cz.partners.bank.backofficegateway.transactions';

export type PaymentGroupKeys =
	(typeof PAYMENT_GROUPS)[keyof typeof PAYMENT_GROUPS];

export const PAYMENT_GROUPS = {
	cardTransactions: 'cardTransactions',
	transfers: 'transfers',
	other: 'other',
} as const;

export const CARD_TRANSACTION_PAYMENT_TYPES = [
	'CARD_PAYMENT',
	'CARD_WITHDRAWAL',
	'CARD_CASH_ADVANCE',
	'CARD_MONEY_TRANSFER',
	'CARD_CASHBACK',
	'CARD_RETURN',
	'CARD_REFUND',
	'CARD_ACCOUNT_FUNDING',
] as const satisfies PaymentTypeV10[];

export const TRANSFER_PAYMENT_TYPES = [
	'TRANSFER',
	'INSTANT_PAYMENT',
	'STANDING_ORDER',
	'DIRECT_DEBIT',
	'SIPO',
	'SEPA_TRANSFER',
	'ZPS_TRANSFER',
	'TRANSFER_CONVERSION',
	'CARD_PAYMENT_SUPER_SAVINGS_ACCOUNT',
	'EXCHANGE',
	'CRYPTO_ASSETS_PURCHASE',
	'CRYPTO_ASSETS_SALE',
	'TD_INIT_PAYMENT',
	'TD_FINAL_TRANSFER',
] as const satisfies PaymentTypeV10[];

export const OTHER_PAYMENT_TYPES = [
	'HOLD_SETTLEMENT',
	'NEGATIVE_INTEREST_CORRECTION',
	'NEGATIVE_INTEREST',
	'POSITIVE_INTEREST_CORRECTION',
	'POSITIVE_INTEREST',
	'PRODUCT_PACKAGE_FEE',
	'INSTALMENT',
	'HOLD_FAU_OFFICE',
	'HOLD_EXECUTION',
	'HOLD_POLICE',
	'HOLD_RISK_AML',
	'HOLD_LIVING_WAGE',
	'HOLD_SETTLEMENT',
	'SWEEP',
	'ONE_TIME_FEE',
	'ZPS_FEE',
	'BALANCE_REALIGNMENT',
	'BANK_INSURANCE_FEE',
	'CRYPTO_ASSETS_PURCHASE_FEE',
	'CRYPTO_ASSETS_SALE_FEE',
] as const satisfies PaymentTypeV10[];

export const INTERNATIONAL_PAYMENT_TYPES = [
	'SEPA_TRANSFER',
	'ZPS_TRANSFER',
] as const satisfies PaymentTypeV10[];

export const PAYMENT_TYPE_WITH_ACCOUNT_BALANCE = [
	'TRANSFER',
	'INSTANT_PAYMENT',
	'STANDING_ORDER',
	'DIRECT_DEBIT',
	'SIPO',
	'NEGATIVE_INTEREST_CORRECTION',
	'NEGATIVE_INTEREST',
	'POSITIVE_INTEREST_CORRECTION',
	'POSITIVE_INTEREST',
	'PRODUCT_PACKAGE_FEE',
	'INSTALMENT',
	'SEPA_TRANSFER',
	'SWEEP',
] as const satisfies PaymentTypeV10[];
